
























































































































import Vue from 'vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import ProjectAddressSearch from '@/components/master-data/address/ProjectAddressSearch.vue'
import { GET_PROJECT_BELEG_DATA, GET_PROJECT_LOOK_UPS, UPDATE_PROJECT_BELEG_DATA } from '@/store/action-types'
import {
  GetBelegDataResponse,
  GetLookupsResponse,
  KonditionResponse,
  KontoResponse,
  RcMitarbeiterResponse, SteuersaetzeResponse, UpdateBelegDataResponse,
  WaehrungenResponse
} from '@/types/service-response'
import { BelegDatenPayload } from '@/types/payload'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'

interface ComponentData {
  isEdit: boolean
  showSearchDialog: boolean
  spediteurId: number
  spediteurGenAdresse: string
  menu1: boolean
  dateFormatted: string
  dateRules: any[]

  kontoplanList: KontoResponse[]
  rcMitarbeiterList: RcMitarbeiterResponse[]
  konditionenLieferungList: KonditionResponse[]
  konditionenVersandList: KonditionResponse[]
  konditionenZahlungList: KonditionResponse[]
  waehrungenList: WaehrungenResponse[]
  steuersaetzeList: SteuersaetzeResponse[]

  zusatzleistungen: number
  kontoZusatzleistungen: number| null
  rabatt: number
  rabattKonto: number | null
  zuschlag: number
  zuschlagKonto: number | null
  mitarbeiter: number | null
  datum: string
  lieferkondition: number | null
  versandart: number | null
  spesen: number
  gebinde: number
  zahlungskondition: number | null
  waehrung: number | null
  steuer: number | null
  beleg: number | null

  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
}

export default Vue.extend({
  name: 'ProjectReprintReceiptData',

  components: {
    ProjectAddressSearch,
    NumberField
  },

  props: {
    belegId: Number
  },

  data (): ComponentData {
    return {
      isEdit: false,
      showSearchDialog: false,
      spediteurId: 0,
      spediteurGenAdresse: '',
      menu1: false,
      dateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],

      kontoplanList: [],
      rcMitarbeiterList: [],
      konditionenLieferungList: [],
      konditionenVersandList: [],
      konditionenZahlungList: [],
      waehrungenList: [],
      steuersaetzeList: [],

      zusatzleistungen: 0.00,
      kontoZusatzleistungen: null,
      rabatt: 0.00,
      rabattKonto: null,
      zuschlag: 0.00,
      zuschlagKonto: null,
      mitarbeiter: null,
      datum: '',
      lieferkondition: null,
      versandart: null,
      spesen: 0.00,
      gebinde: 0.00,
      zahlungskondition: null,
      waehrung: null,
      steuer: null,
      beleg: null,

      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false
    }
  },

  watch: {
    belegId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    },

    dateFormatted (newVal: string): void {
      if(newVal) {
        this.datum = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.datum = ''
      }
    },
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onFocusDate (): void {
      setTimeout(() => {
        if(!this.menu1) {
          this.menu1 = true
        }
      }, 100)
    },

    onBlurDate (): void {
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onDateChange (date: string): void {
      this.dateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onZusatzleistungenChange (): void {
      if(this.zusatzleistungen == null) {
        this.zusatzleistungen = 0.0
      }
    },

    onRabattChange (): void {
      if(this.rabatt == null) {
        this.rabatt = 0.00
      }
    },

    onZuschlagChange (): void {
      if(this.zuschlag == null) {
        this.zuschlag = 0.00
      }
    },

    onSpesenChange (): void {
      if(this.spesen == null) {
        this.spesen = 0.00
      }
    },

    onGebindeChange (): void {
      if(this.gebinde == null) {
        this.gebinde = 0.00
      }
    },

    onEditClick (): void {
      this.isEdit = true
      this.onSearchAddressClick()
    },

    onSearchAddressClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onSelectedAddress (data: SearchAddress): void {
      this.closeSearchDialog()
      this.spediteurId = data.id
      this.spediteurGenAdresse = data.genAdresse
    },

    onCancelButtonClick (): void {
      this.isEdit = false
      if(this.belegId) {
        this.fetchData()
      }
    },

    onSaveButtonClick (): void {
      if(this.beleg) {
        this.updateBelegData()
      }
    },

    async updateBelegData (): Promise<void> {
      const payload: BelegDatenPayload = {
        Beleg: this.beleg!,
        Spediteur: this.spediteurId ? this.spediteurId : 0,
        SpediteurGenAdresse: this.spediteurGenAdresse,
        Zusatzleistungen: this.zusatzleistungen,
        KontoZusatzleistungen: this.kontoZusatzleistungen,
        Rabatt: this.rabatt,
        RabattKonto: this.rabattKonto,
        Zuschlag: this.zuschlag,
        ZuschlagKonto: this.zuschlagKonto,
        Mitarbeiter: this.mitarbeiter,
        Datum: this.datum,
        Lieferkondition: this.lieferkondition,
        Versandart: this.versandart,
        Spesen: this.spesen,
        Gebinde: this.gebinde,
        Zahlungskondition: this.zahlungskondition,
        Waehrung: this.waehrung,
        Steuer: this.steuer
      }

      try {
        this.loading = true
        const response: UpdateBelegDataResponse = await this.$store.dispatch(UPDATE_PROJECT_BELEG_DATA, payload)
        this.loading = false
        if(!response.IsError) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.isEdit = false
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchData (): Promise<void> {
      const response: GetBelegDataResponse = await this.$store.dispatch(GET_PROJECT_BELEG_DATA, this.belegId)
      if(!response.IsError && response.BelegDaten) {
        this.beleg = response.BelegDaten.Beleg
        this.spediteurId = response.BelegDaten.Spediteur ? response.BelegDaten.Spediteur : 0
        this.spediteurGenAdresse = response.BelegDaten.SpediteurGenAdresse ? response.BelegDaten.SpediteurGenAdresse : ''
        this.zusatzleistungen = response.BelegDaten.Zusatzleistungen !== null ? parseFloat(response.BelegDaten.Zusatzleistungen.toFixed(2)) : 0.00
        this.kontoZusatzleistungen = response.BelegDaten.KontoZusatzleistungen
        this.rabatt = response.BelegDaten.Rabatt !== null ? parseFloat(response.BelegDaten.Rabatt.toFixed(2)) : 0.00
        this.rabattKonto = response.BelegDaten.RabattKonto
        this.zuschlag = response.BelegDaten.Zuschlag !== null ? parseFloat(response.BelegDaten.Zuschlag.toFixed(2)) : 0.00
        this.zuschlagKonto = response.BelegDaten.ZuschlagKonto
        this.mitarbeiter = response.BelegDaten.Mitarbeiter
        this.datum = response.BelegDaten.Datum ? moment(response.BelegDaten.Datum).format('YYYY-MM-DD') : ''
        this.dateFormatted = response.BelegDaten.Datum ? moment(response.BelegDaten.Datum).format('DD.MM.YYYY') : ''
        this.lieferkondition = response.BelegDaten.Lieferkondition
        this.versandart = response.BelegDaten.Versandart
        this.spesen = response.BelegDaten.Spesen !== null ? parseFloat(response.BelegDaten.Spesen.toFixed(2)) : 0.00
        this.gebinde = response.BelegDaten.Gebinde !== null ? parseFloat(response.BelegDaten.Gebinde.toFixed(2)) : 0.00
        this.zahlungskondition = response.BelegDaten.Zahlungskondition
        this.waehrung = response.BelegDaten.Waehrung
        this.steuer = response.BelegDaten.Steuer
      }
    },

    async fetchLookups (): Promise<void> {
      const response: GetLookupsResponse = await this.$store.dispatch(GET_PROJECT_LOOK_UPS)
      if(!response.IsError) {
        this.kontoplanList = response.Kontoplan
        this.rcMitarbeiterList = response.RcMitarbeiter
        this.konditionenLieferungList = response.KonditionenLieferung
        this.konditionenVersandList = response.KonditionenVersand
        this.konditionenZahlungList = response.KonditionenZahlung
        this.waehrungenList = response.Waehrungen
        this.steuersaetzeList = response.Steuersaetze
      }
    }
  },

  mounted () {
    this.fetchLookups()
    if(this.belegId) {
      this.fetchData()
    }
  }
})
